import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { useDispatch, useSelector } from "react-redux";
import VehicleCardHome from "./VehicleCardHome";
import VehicleCardHomeSkeleton from "./VehicleCardHomeSkeleton";
import { getVehicles } from "../../../redux/features/vehicle/vehicleService";
import { selectVehicleList } from "../../../redux/features/vehicle/vehicleSlice";

const CarGridHome = ({
  dividedDesign,
  pagination,
  limit,
  search,
  chassisNo,
  steering,
  wheelDrive,
  exteriorCondition,
  interiorCondition,
  noOfDoors,
  noOfSeats,
  country,
  make,
  model,
  modelCode,
  vehicleType,
  interiorColor,
  exteriorColor,
  fuel,
  transmission,
  minPrice,
  maxPrice,
  yearFrom,
  yearTo,
  mileageFrom,
  mileageTo,
  engineCCFrom,
  engineCCTo,
  isFeatured,
  isPopular,
  status,
}) => {

  const dispatch = useDispatch();

  const {status: AllVehiclesState, data: AllVehicles} = useSelector(selectVehicleList);

  const [skip, setSkip] = useState(0);

  useEffect(() => {
    dispatch(
      getVehicles({
        limit,
        skip,
        search,
        chassisNo,
        steering,
        wheelDrive,
        exteriorCondition,
        interiorCondition,
        noOfDoors,
        noOfSeats,
        country,
        make,
        model,
        modelCode,
        vehicleType,
        interiorColor,
        exteriorColor,
        fuel,
        transmission,
        minPrice,
        maxPrice,
        yearFrom,
        yearTo,
        mileageFrom,
        mileageTo,
        engineCCFrom,
        engineCCTo,
        isFeatured,
        isPopular,
        status,
      })
    );
  }, [
    limit,
    skip,
    search,
    chassisNo,
    steering,
    wheelDrive,
    exteriorCondition,
    interiorCondition,
    noOfDoors,
    noOfSeats,
    country,
    make,
    model,
    modelCode,
    vehicleType,
    interiorColor,
    exteriorColor,
    fuel,
    transmission,
    minPrice,
    maxPrice,
    yearFrom,
    yearTo,
    mileageFrom,
    mileageTo,
    engineCCFrom,
    engineCCTo,
    isFeatured,
    isPopular,
    status,
    dispatch
  ]);

  return (
    <>
      <div
        className={`${styles.mainDiv} ${
          dividedDesign ? styles.mainDivSearch : ""
        }`}
      >

        {AllVehiclesState === 'succeeded' &&
          AllVehicles.length > 0 &&
          AllVehicles.map((vehicle, i) => (
            <div key={i}>
              <VehicleCardHome
                id={vehicle.id}
                name={vehicle.name}
                imageUrl={vehicle.image_url}
                price={
                  vehicle.vehicle_costs?.[0]?.selling_price
                    ? vehicle.vehicle_costs[0].selling_price
                    : null
                }
                wheelDrive={vehicle.wheel_drive}
                engineCC={vehicle.engine_capacity}
                mileage={vehicle.mileage}
                fuelType={vehicle.fuel?.name}
                gearType={vehicle.transmission?.name}
                tag={
                  vehicle.isFeatured
                    ? "FEATURED"
                    : vehicle.isPopular
                    ? "POPULAR"
                    : ""
                }
                make={vehicle.make?.name}
                model={vehicle.model?.name}
              />
            </div>
          ))}

        {(AllVehiclesState === 'loading' || AllVehiclesState === 'idle') &&
          Array.from(Array(12), (_, i) => (
            <div key={i}>
              <VehicleCardHomeSkeleton />
            </div>
          ))}
      </div>

      {/* Pagination */}
      {pagination && (
        <div className={styles.pagination}>
          {AllVehiclesState.pageCount > 1 &&
            Array.from(
              Array(AllVehiclesState.pageCount),
              (_, i) => (
                <button key={i} onClick={() => setSkip(i)}>
                  {i + 1}
                </button>
              )
            )}
        </div>
      )}
    </>
  );
};

export default CarGridHome;